// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Voucher from '../_raw/ui/icon_voucher.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Voucher);
